import React, { useState, useEffect } from 'react';
import { Users as UsersIcon, RefreshCw } from 'lucide-react';
import API_BASE_URL from '../config';
import UserActionMenu from '../components/admin/UserActionMenu';

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch(`${API_BASE_URL}/api/admin/users`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch platform accounts.');
      }

      const result = await response.json();
      if (result.success) {
        setUsers(result.data);
      }
    } catch (err) {
      console.error(err);
      setError('Could not connect to the API. Displaying simulation accounts.');
      // Fallback simulation data
      setUsers([
        { id: '1', name: 'Rajesh Kumar', email: 'rajesh@gmail.com', role: 'Owner', gymName: 'Muscle Factory, Hyd', isBanned: false },
        { id: '2', name: 'Priya Sharma', email: 'priya@gmail.com', role: 'Owner', gymName: 'Iron House, Vijayawada', isBanned: true, banReason: 'Violation of Terms' },
        { id: '3', name: 'Kiran Goud', email: 'kiran@gmail.com', role: 'Trainer', gymName: 'Muscle Factory, Hyd', isBanned: false }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-white tracking-tight">Platform Accounts</h1>
          <p className="text-gray-400 text-sm mt-1">Audit accounts, manage credentials, and review admin actions.</p>
        </div>
        <button
          onClick={fetchUsers}
          disabled={loading}
          className="flex items-center px-4 py-2 bg-[#1E293B] border border-[#334155] hover:border-[#6CD800] rounded-lg text-sm text-gray-300 transition-all hover:text-white"
        >
          <RefreshCw size={16} className={`mr-2 ${loading ? 'animate-spin text-[#6CD800]' : ''}`} />
          Refresh
        </button>
      </div>

      {error && (
        <div className="bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 text-sm rounded-lg p-4">
          {error}
        </div>
      )}

      <div className="bg-[#0F172A] border border-[#1E293B] rounded-xl shadow-lg overflow-hidden">
        {loading ? (
          <div className="flex justify-center items-center h-48 text-[#6CD800]">
            <RefreshCw size={24} className="animate-spin mr-2" />
            Loading platform accounts...
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm text-gray-300">
              <thead className="text-xs text-gray-400 uppercase bg-[#0B0F19] border-b border-[#1E293B]">
                <tr>
                  <th className="px-6 py-4">Account Name</th>
                  <th className="px-6 py-4">Email</th>
                  <th className="px-6 py-4">System Role</th>
                  <th className="px-6 py-4">Workspace Scope</th>
                  <th className="px-6 py-4">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#1E293B]">
                {users.map(user => (
                  <tr key={user.id} className="hover:bg-[#1E293B]/20">
                    <td className="px-6 py-4 font-semibold text-white flex items-center">
                      <UsersIcon size={16} className="text-[#6CD800] mr-2" />
                      {user.name}
                      {user.isBanned && (
                        <span style={{
                          fontSize: 10, fontWeight: 700, letterSpacing: "0.05em",
                          background: "#2a0a0a", color: "#ef4444",
                          border: "1px solid #ef4444", borderRadius: 4,
                          padding: "2px 6px", marginLeft: 8, verticalAlign: "middle"
                        }}>
                          BANNED
                        </span>
                      )}
                    </td>
                    <td className="px-6 py-4 text-gray-400">{user.email}</td>
                    <td className="px-6 py-4 font-mono text-xs">{user.role}</td>
                    <td className="px-6 py-4 text-gray-400 text-sm">{user.gymName}</td>
                    <td className="px-6 py-4">
                      <UserActionMenu
                        user={user}
                        onActionComplete={fetchUsers}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Users;
